import * as focusTrap from 'focus-trap';

export function create(el, options = {}) {
	const defaultOptions = {
		escapeDeactivates: false,
		allowOutsideClick: true,
		preventScroll: true,
		initialFocus: el
	};
	return focusTrap.createFocusTrap(el, {
		...defaultOptions,
		...options
	});
}

export function activate(trap) {
	trap.activate();
}

export function deactivate(trap) {
	trap.deactivate();
}
